import React, { Component } from "react";
import { connect } from "react-redux";
import { getSettingByID, updateSetting } from "../../store/ducks/mobileAppsPromoSetting/actions";
import Auxiliary from "../../hoc/Auxiliary/Auxiliary";
// import StringInput from "../../components/Input/StringInput/StringInput";
// import Select from "../../components/Input/Select/Select";
import Button from "../../components/Button/Button";
import { filterErrorHandler, formValidation } from "../../hoc/Shared/utility";
// import DatePicker from "react-datepicker";
import Swal from "sweetalert2";
import * as moment from 'moment';
import { withNamespaces } from "react-i18next";
import ValidationError from "../../components/ValidationError/ValidationError";
import Skeleton from "react-loading-skeleton";

class MobileAppsPromoSettingEdit extends Component {
    constructor(props) {
        super(props);
        this.state = {
            name: "",
            start_time: "",
            end_time: "",
            setting_list: [{listIndex: Math.random(), key: "", value: ""}],
            loading: true,
            error_message: [],
            touched: false,
            isGameType: false,
            proceedUpdate: true
        };
        this.handleChange = this.handleChange.bind(this);
        this.handleSettingListChange = this.handleSettingListChange.bind(this);
        this.addRecord = this.addRecord.bind(this);
        this.removeRecord = this.removeRecord.bind(this);
    }

    componentDidMount() {
        formValidation("setting_form");
        
        let getSettingData = {};
        getSettingData.id = this.props.settingID;
        this.props.getSettingByID(getSettingData);
    }

    shouldComponentUpdate(nextProps, nextState) {
        if (nextProps.details !== undefined && nextProps.details !== this.props.details && nextState.loading === true) {
            if (nextProps.details.responseCode === 200 && nextProps.details.msgType === 'success') {
                let settingData = Object.entries(nextProps.details.data.result.value);
                let settingList = [];

                settingData.map((item, idx) => {
                    return settingList.push({listIndex: Math.random(), key: item[0], value: item[1]});
                });

                this.setState({
                    edit_id: nextProps.details.data.result.id,
                    setting_list: settingList,
                    start_time: new Date(nextProps.details.data.result.start_date),
                    end_time: new Date(nextProps.details.data.result.end_date),
                    loading: false,
                });
            }
            else {
                this.setState({
                    edit_id: null,
                    setting_list: [{listIndex: Math.random(), key: "", value: ""}],
                    start_time: "",
                    end_time: "",
                    loading: true
                }, () => {
                    filterErrorHandler(nextProps.details.message);
                })
            }
        }

        if (nextProps.updateResult !== this.props.updateResult && nextProps.updateResult !== undefined) {
            if (nextProps.updateResult.responseCode === 200 && nextProps.updateResult.msgType === 'success') {
                this.setState({ touched: false });
                const { t } = this.props;
                Swal.fire({
                    title: t("global.record-updated"),
                    icon: nextProps.updateResult.msgType,
                    confirmButtonText: t("global.ok"),
                }).then((result) => {
                    if (result.isConfirmed) {
                        this.props.refreshHandler();
                        this.props.changePageHandler("listing");
                    }
                });
            } else {
                this.setState({
                    touched: true,
                    error_message: nextProps.updateResult.message,
                });
                Swal.close();
            } 
        }
        return true;
    }

    handleStartTimeChange = (date) => {
        this.setState({
            start_time: date,
        });
    };

    handleEndTimeChange = (date) => {
        this.setState({
            end_time: date
        });
    };

    updateSettingHandler = (e) => {
        e.preventDefault();
        const { t } = this.props;
        Swal.fire({
            title: t("global.confirmation"),
            text: t("global.are-you-sure"),
            icon: "warning",
            showCancelButton: true,
            confirmButtonText: t("global.update"),
            cancelButtonText: t("global.cancel"),
        }).then((result) => {
            if (result.isConfirmed) {
                Swal.fire({
                    title: "",
                    allowOutsideClick: false,
                    allowEscapeKey: false,
                    allowEnterKey: false,
                    didOpen: () => {
                        Swal.showLoading();
                    },
                });
                
                let valueArray = [];
                this.setState({proceedUpdate: true});
                
                this.state.setting_list.forEach((item, idx) => {
                    valueArray[item.key] = item.value;                                            
                });

                const valueJson = JSON.stringify(Object.assign({}, valueArray));   

                let updateSettingData = {};
                updateSettingData.id = this.state.edit_id;
                updateSettingData.mobile_app_promo_setting = valueJson;
                updateSettingData.mobile_app_promo_start_time = moment(this.state.start_time).format("yyyy-MM-DD HH:mm");
                updateSettingData.mobile_app_promo_end_time = moment(this.state.end_time).format("yyyy-MM-DD HH:mm");

                if (this.state.proceedUpdate === true) {
                    this.props.updateSetting(updateSettingData);
                }
            }
        });
    };

    addRecord = () => {
        if(this.state.setting_list.length < 20) {
            this.setState((prevState) => ({
                setting_list: [...prevState.setting_list, {listIndex: Math.random(), key: "", value: ""}],
            }));
        }
    };

    removeRecord = (i) => {
        this.setState({
            setting_list: this.state.setting_list.filter((item, idx) => i !== idx)
        })
    }

    handleChange = (event) => {
        this.setState({
            [event.target.name]: event.target.value,
        });

        if (event.target.name === 'name') {
            if (event.target.value === 'Game Type') {
                this.setState({
                    isGameType: true
                });
            } else {
                this.setState({
                    isGameType: false
                });
            }
        }
    };

    handleSettingListChange = (event, idx) => {
        let dataID = 0;
        if (this.state.isGameType === true && event.target.name === 'value') {
            dataID = idx;
        } else {
            dataID = event.target.dataset.id;            
        }

        let setting_list = [...this.state.setting_list];
        setting_list[dataID][event.target.name] = event.target.value;
        this.setState({setting_list});
    }

    render() {
        const { t } = this.props;
        let display = null;
        if (!this.state.loading) {
            display = (
                <div className="row row-sm">
                    <div className="col-lg-12 col-xl-12 col-md-12 col-sm-12">
                        <div className="card box-shadow-0">
                            <div className="card-header">
                                <h4 className="card-title mb-1">{t("mobile-app-promo.edit-setting")}</h4>
                            </div>

                            <div className="card-body pt-0">
                                <form method="post" id="setting_form" className="form-horizontal" onSubmit={this.updateSettingHandler} noValidate>
                                    <ValidationError formName="setting_form" touched={this.state.touched} message={this.state.error_message} />
                                    {/*
                                    <div className="row">
                                        
                                        <div className="col-md-4">
                                            <div className="form-group">
                                                <label htmlFor="start-time">{t("mobile-app-promo.start-time")}</label>
                                                <DatePicker
                                                     name="start_time"
                                                     className="form-control"
                                                     selected={this.state.start_time}
                                                     onChange={this.handleStartTimeChange}
                                                     minDate={new Date()}
                                                     showTimeSelect
                                                     dateFormat="yyyy-MM-dd HH:mm"
                                                     timeFormat="HH:mm"
                                                     timeIntervals={15}
                                                     timeCaption="time"
                                                     autoComplete="off"
                                                />
                                            </div>
                                        </div>

                                        <div className="col-md-4">
                                            <div className="form-group">
                                                <label htmlFor="end-time">{t("mobile-app-promo.end-time")}</label>
                                                <DatePicker
                                                     name="end_time"
                                                     className="form-control"
                                                     selected={this.state.end_time}
                                                     onChange={this.handleEndTimeChange}
                                                     minDate={new Date()}
                                                     showTimeSelect
                                                     dateFormat="yyyy-MM-dd HH:mm"
                                                     timeFormat="HH:mm"
                                                     timeIntervals={15}
                                                     timeCaption="time"
                                                     autoComplete="off"
                                                />
                                            </div>
                                        </div>
                                    </div>
                                    */}
                                    <div className="row">
                                        <div className="col-md-12">
                                            <div className='row'>
                                                <h3 className="card-title col-8">{t("mobile-app-promo.value")}</h3>
                                                {/* <div className="row col-4 justify-content-end mb-2 pr-0">
                                                    <button type="button" className="btn btn-info" onClick={(e) => this.addRecord(e)}>
                                                    <i className="fa fa-plus"></i> {t("mobile-app-promo.add")}
                                                    </button>
                                                </div> */}
                                            </div>
                                            <div className="table-responsive" style={{overflowY:'auto'}}>
                                                <table className="table" id="setting_table" style={{minWidth:500}}>
                                                    <thead className="text-center bg-primary">
                                                        <tr>
                                                            <th className="text-white p-2">{t("mobile-app-promo.no")}</th>
                                                            <th className="text-white p-2">{t("mobile-app-promo.key")}</th>
                                                            <th className="text-white p-2">{t("mobile-app-promo.value")}</th>
                                                            <th style={{ width: "5%" }}>
                                                                {/* <button
                                                                    type="button"
                                                                    name="add"
                                                                    className="add btn btn-sm btn-success text-center mt-1"
                                                                    onClick={(e) => this.addRecord(e)}>
                                                                    <i className="fas fa-plus-square fa-2x"></i>
                                                                </button> */}
                                                            </th>
                                                        </tr>
                                                    </thead>
                                                    <tbody>
                                                        {this.state.setting_list.map((item, idx) => {
                                                            return (
                                                                <tr key={idx} className="text-center">
                                                                    <td>{idx + 1}</td>
                                                                    <td key={`key-${idx}`} width="45%">
                                                                        <input
                                                                            id="key"
                                                                            name="key"
                                                                            data-id={idx}
                                                                            className="form-control"
                                                                            placeholder={t("mobile-app-promo.key")}
                                                                            value={item.key}
                                                                            onChange={this.handleSettingListChange}
                                                                            autoComplete="off"
                                                                            disabled
                                                                        />
                                                                    </td>
                                                                    <td key={`value-${idx}`} width="45%">
                                                                    
                                                                      
                                                                            <input
                                                                                id="value"
                                                                                name="value"
                                                                                data-id={idx}
                                                                                className="form-control"
                                                                                placeholder={t("mobile-app-promo.value")}
                                                                                value={item.value}
                                                                                onChange={this.handleSettingListChange}
                                                                                autoComplete="off"
                                                                                required
                                                                            />
                                                           
                                                                    
                                                                    </td>
                                                                    {/* <td>
                                                                        <i className="fa fa-trash" style={{color:'red', cursor:'pointer'}} onClick={() => this.removeRecord(idx)}></i>
                                                                    </td> */}
                                                                </tr>
                                                            );
                                                        })}
                                                    </tbody>
                                                </table>
                                            </div>
                                        </div>
                                    </div>

                                    <div className="form-group mb-0 mt-3 justify-content-end">
                                        <div>
                                            <Button typeButton="submit" classValue="btn btn-blue" idValue="submit" buttonName={t("global.save")} />
                                        </div>
                                    </div>
                                </form>
                            </div>
                        
                        </div>
                    </div>
                </div>
            );
        } else {
            display = (
                <div className="row row-sm">
                    <div className="col-lg-12 col-xl-12 col-md-12 col-sm-12">
                        <div className="card box-shadow-0">
                            <div className="card-header">
                                <h4 className="card-title mb-1">{t("gold_digger.edit_setting")}</h4>
                            </div>
                            <div className="card-body pt-0">
                                <Skeleton count={4} />
                            </div>
                        </div>
                    </div>
                </div>
            );
        }
        return (
            <Auxiliary>
                <div className="breadcrumb-header">
                    <div className="d-flex">
                        <div className="my-auto">
                            <Button
                                typeButton="button"
                                classValue="btn btn-back-outline"
                                idValue="back"
                                buttonName={<i className="angle fe fe-chevron-left"></i>}
                                clicked={() => this.props.changePageHandler("listing")}
                            />
                        </div>
                    </div>
                    <div className="my-auto">
                        <div className="d-flex">
                            <h4 className="content-title mb-0 my-auto ml-2">{t("mobile-app-promo.mobile-app-promo-setting")}</h4>
                        </div>
                    </div>
                </div>
                {display}
            </Auxiliary>
        );
    }
}

const mapStateToProps = (state) => {
    return {
        details: state.mobileAppsPromoSetting.details,
        updateResult: state.mobileAppsPromoSetting.update,
    };
};

const mapDispatchToProps = (dispatch) => {
    return {
        getSettingByID: (data) => dispatch(getSettingByID(data)),
        updateSetting: (data) => dispatch(updateSetting(data)),
    };
};

export default connect(mapStateToProps, mapDispatchToProps)(withNamespaces("translation")(MobileAppsPromoSettingEdit));
